export const supportedTypes = `.JPG , .JPEG , .PNG , .GIF , .SVG ,
.PSD , .DXF , .AI , .SKETCH , .HEIC , .DWG , .MP3 , .WAV , .FLAC ,
.M4A , .m4p , .MP4 , .AVI , .MOV , .XVID , .MKV ,
.OGV , .VOB , .3GP , .MPG , .MPE , .MPEG , .divx , .GPX , .XYZ , .EXE , .TTF ,
.OTF , .WEB , .WOFF2 , .WOFF , .ZIP , .RAR , .GZIP , .TAR , .GZ , .XLS ,
.XLSX , .XLSM , .CSV , .DOC , .DOCX , .ODT, .XPS , .TXT , .ODP,
.PPS , .PPSX , .PPT , .PPTX , .PDF, .KEY, .NUMBERS, .PAGES, .GPX, .KML, .KMZ`;
